<template>
  <Navbar />
</template>
<script>
import Navbar from "@/components/AllNavBar.vue";
import store from "@/store";
export default {
  components: { Navbar },
  data() {
    return {
      r7: JSON.parse(store.state.randp.r7).create,
    };
  },
  async mounted() {
    // const user = this.$cookies.get("data");
    if (this.r7 != true) {
      this.$root.$router.push({
        path: "/SignIn",
      });
    }
  },

  methods: {},
  watch: {},
};
</script>
